import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ConstantsService } from '../services/constants.service';

@Component({
  selector: 'app-gaze-delete-account',
  templateUrl: './gaze-delete-account.component.html',
  styleUrls: ['./gaze-delete-account.component.scss']
})
export class GazeDeleteAccountComponent implements OnInit {
  constructor(
    public constants: ConstantsService,
    private location: Location
  ) {}

  ngOnInit(): void {}

  formatText(text: string): string {
    if (!text) return '';
    return text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
  }

  OnClickClose() {
    this.location.back();
  }
}
